import React from 'react';
import DashboardLayout from '../components/layouts/DashboardLayout';

// ============================================================
// DashboardPage – página raíz del dashboard
// Aquí se montará el contenido de cada módulo a futuro
// ============================================================

const DashboardPage: React.FC = () => {
  return <DashboardLayout />;
};

export default DashboardPage;
